import React from 'react';
import { TextField } from '@mui/material';

export default function DateTimePreview({ field, onUpdate, palette, theme }) {
  const isDate = field.type === 'date';

  return (
    <TextField
      size="small"
      fullWidth
      type={isDate ? 'date' : 'time'}
      disabled
      InputLabelProps={{ shrink: true }}
    />
  );
}
